var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C9 2.44786 9.44786 2 10 2H13C13.5521 2 14 2.44786 14 3V11.5C14 12.8811 12.8811 14 11.5 14H2C1.44786 14 1 13.5521 1 13V10C1 9.44786 1.44786 9 2 9H5V7C5 6.44786 5.44786 6 6 6H9V3ZM13 3H10V6C10 6.55214 9.55214 7 9 7H6V9C6 9.55214 5.55214 10 5 10H2V13H11.5C12.3289 13 13 12.3289 13 11.5V3Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSteps);
export default __webpack_public_path__ + "static/media/icon_steps.82a8a8029a05b57aa76dfec0886cfd25.svg";
export { ForwardRef as ReactComponent };